export class AcquiredFund {
  id: string = null;
  sourceId: string = null;
  name: string = null;
  document: string = null;
  administrator: string = null;
  isManualSettlementDate: boolean = false;
}
